import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Grid,
    InputAdornment,
    Stack,
    TextField,
} from "@mui/material";

import CalculateIcon from "@mui/icons-material/Calculate";
import { INPUT_VALIDATION } from "../../../constants";
import { gsdFromHeight } from "../../utils/sopCalculation";
import { roundNumber } from "../../utils/roundNumber";
import { useForm } from "react-hook-form";
import { useState } from "react";

export function SensorSimulatorGSD() {
    const [gsd, setGsd] = useState(null);

    const {
        handleSubmit,
        register,
        formState: { errors },
    } = useForm({
        defaultValues: {
            sensorWidth: null,
            pixelWidth: null,
            realFocalLength: null,
            height: null,
        },
    });

    const onSubmit = (payload) => {
        const gsdResult = gsdFromHeight(
            payload.height,
            payload.sensorWidth,
            payload.pixelWidth,
            payload.realFocalLength
        );

        setGsd(roundNumber(gsdResult, 3));
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Card>
                <CardHeader title="GSD" />

                <CardContent>
                    <Grid container spacing={2}>
                        <Grid size={2}>
                            <TextField
                                id="sensorWidth"
                                fullWidth
                                type="number"
                                label="Sensor width"
                                error={Boolean(errors.sensorWidth)}
                                helperText={errors.sensorWidth?.message}
                                {...register("sensorWidth", {
                                    required: INPUT_VALIDATION.REQUIRED_SHORT,
                                    valueAsNumber: true,
                                    validate: (value) =>
                                        value > 0 || INPUT_VALIDATION.POSITIVE,
                                })}
                                inputProps={{
                                    step: "0.01",
                                    inputMode: "decimal",
                                }}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            mm
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField
                                id="pixelWidth"
                                fullWidth
                                type="number"
                                label="Picture width"
                                error={Boolean(errors.pixelWidth)}
                                helperText={errors.pixelWidth?.message}
                                {...register("pixelWidth", {
                                    required: INPUT_VALIDATION.REQUIRED_SHORT,
                                    valueAsNumber: true,
                                    validate: (value) =>
                                        value > 0 || INPUT_VALIDATION.POSITIVE,
                                })}
                                inputProps={{
                                    inputMode: "numeric",
                                }}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            px
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField
                                id="realFocalLength"
                                fullWidth
                                type="number"
                                label="Real focal length"
                                error={Boolean(errors.realFocalLength)}
                                helperText={errors.realFocalLength?.message}
                                {...register("realFocalLength", {
                                    required: INPUT_VALIDATION.REQUIRED_SHORT,
                                    valueAsNumber: true,
                                    validate: (value) =>
                                        value > 0 || INPUT_VALIDATION.POSITIVE,
                                })}
                                inputProps={{
                                    step: "0.01",
                                    inputMode: "decimal",
                                }}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            mm
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField
                                id="height"
                                fullWidth
                                type="number"
                                label="Distance"
                                error={Boolean(errors.height)}
                                helperText={errors.height?.message}
                                {...register("height", {
                                    required: INPUT_VALIDATION.REQUIRED_SHORT,
                                    valueAsNumber: true,
                                    validate: (value) =>
                                        value > 0 || INPUT_VALIDATION.POSITIVE,
                                })}
                                inputProps={{
                                    step: "0.01",
                                    inputMode: "decimal",
                                }}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            m
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>

                        <Grid size={2}>
                            <Stack direction="row" justifyContent="flex-end">
                                <Button
                                    variant="contained"
                                    startIcon={<CalculateIcon />}
                                    type="submit"
                                >
                                    Compute
                                </Button>
                            </Stack>
                        </Grid>

                        <Grid size={2}>
                            <TextField
                                id="result"
                                fullWidth
                                type="text"
                                label="Result"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                InputProps={{
                                    readOnly: true,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            mm
                                        </InputAdornment>
                                    ),
                                }}
                                value={gsd ?? ""}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </form>
    );
}
